export default "__VITE_ASSET__BbnAJjmO__"